<template>
	<div class="task_list_item" @click="onClick">
		<div class="task_list_item-left">
			<div class="title van-ellipsis" :class="label?'maxWidth':''">{{title}}</div>
			<div class="label">{{label}}<slot name="label"></slot></div>
		</div>
		<div class="task_list_item-right" :class="`text_color_${rightTextType}`">
			{{rightText}}
			<slot name="right"></slot>
		</div>
	</div>
</template>
<script>
export default {
    name: 'TaskListItem',
    props: {
        title: {
            type: String,
            default: ''
        },
        rightTextType: {
            type: String,
            default: 'primary'
        },
        label: {
            type: String,
            default: ''
        },
        rightText: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick () {
            this.$emit('click')
        }
    }
}
</script>
<style lang="less" scoped>
.task_list_item {
	height: 122px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	&-left {
		display: flex;
		align-items: center;
		justify-content: center;
		.title {
			font-size: 32px;
			color: #1f2329;
			margin-right: 16px;
		}
		.maxWidth {
			max-width: 260px;
		}
		.label {
			font-size: 28px;
			color: @gray-9;
		}
	}
	&-right {
		font-size: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.text_color_primary {
		color: @primary;
	}
	.text_color_info {
		color: #8f959e;
	}
}
</style>